import { citySchema } from "@redotech/redo-model/geographic-unit";
import { z } from "zod";

export const getCities = {
  input: z.object({ countryCode: z.string(), stateCode: z.string() }),
  output: z.array(citySchema),
};
